<template>
  <article class="popup right-popup popup-padding">
    <div class="popup-top">
      <div class="popup-top_names">
        <h2 class="title">{{name}} </h2>
        <h3 class="type">ID - {{id}}</h3>
      </div>
      <div class="popup-top_btns">
        <question-btn :bottom="true" :text="$t('labels.prompt')"></question-btn>
        <close-btn class="static"></close-btn>
      </div>
    </div>
    <toggle-sections-right @changeSec="toggleSection($event)"
                           :sections="sections">

    </toggle-sections-right>
    <transition name="fade" mode="out-in">
      <more v-if="activeSection == 'more'"
            @enableEdit="enableEdit"
            @error="disableSaveBtn"
            @good="enableSaveBtn"
            :disabled="disabled"></more>
      <logs v-else-if="activeSection == 'logs'"></logs>
    </transition>
    <div class="btns-cont">
      <button type="button"
              v-if="!disabled && !checkBtn && !disableBtn"
              class="btn btn-green"
              @click="updateUserData">
        <span v-if="success">
          {{$t('btns.success')}}
        </span>
        <span v-else>{{$t('btns.save')}}</span>
      </button>
      <btns-generator v-for="(btn, i) in editedUser.controls"
                      :type="btn.type"
                      @delUser="delUser"
                      @repeatActivation="repeatActivation"
                      @enterAsUser="enterAsUser"
                      :copy-id="id"
                      :activation-link="activationLink"
                      :key="i + btn.type"></btns-generator>
    </div>
  </article>
</template>

<script>
  import more from './showMoreMore'
  import logs from './showMoreLogs'
  import {showMoreUsers} from "../../../../mixins/users/showMore";

  export default {
    name: 'showMoreUser',
    mixins: [showMoreUsers],
    components: {
      more,
      logs
    },
    data() {
      return {
        disabled: true,
        success: false,
        name: '',
        id: '',
        activationLink: 'https://google.com',
        type: '',
        activeSection: 'more',
        disableBtn: false,
        newPass: '',
      }
    },
    computed: {
      checkBtn() {
        if (!this.editedUser.first_name ||
            !this.editedUser.second_name ||
            !this.editedUser.email
        ) {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      updateUserData() {
        this.updateUserInServer({
          token: this.token,
          description: this.editedUser.description,
          first_name: this.editedUser.first_name,
          second_name: this.editedUser.second_name,
          email: this.editedUser.email,
          phone: this.editedUser.phone,
          id: this.editedUser.user_id || this.editedUser.id,
          pass: this.newPass
        }).then(() => {
          this.success = true;
          setTimeout(() => {
            this.success = false;
            this.disabled = true;
          }, 2500)
        })
      },
      disableSaveBtn() {
        this.disableBtn = true
      },
      enableSaveBtn(e) {
        this.disableBtn = false;
        this.newPass = e.newPass;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
